export default (arr, random = Math.random) => arr && arr[Math.floor(random() * arr.length)]
